var map = {
	"./slider (1).png": "4641",
	"./slider (2).png": "54f4",
	"./slider (3).png": "a8fb",
	"./slider (4).png": "98bd",
	"./slider (5).png": "3403",
	"./slider (6).png": "6fa5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06b7";